// extracted by mini-css-extract-plugin
module.exports = {"root":"dark-mode-button-module--root--3THqa"};